// @ts-nocheck: converted from JS

import { DateTimeRenderer } from '@/components/UI/DateRenderers/DateRenderers';
import GroupLabel from '@/components/UI/GroupLabel/GroupLabel';
import { _isNil } from '@/littledash';

export const createPayload = (request, requestTemplateId) => {
  const payload = {
    form_data: request.form_data,
  };
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  if (requestTemplateId) {
    payload.template_id = requestTemplateId;
  }
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  if (request.due_date) {
    payload.due_date = request.due_date;
  }
  return payload;
};

export const GroupContainer = ({ children }) => {
  return <div className="ui-card pa3 mb4">{children}</div>;
};

const cellWidth = 180;

export const sampleColumns = (dispatch) => [
  {
    id: 'sampleId',
    header: 'Sample ID',
    accessorKey: 'sample_id',
    size: cellWidth,
    cell: ({ row: { original } }) => (
      <a
        className="link blue lh-title db"
        onClick={() =>
          dispatch({
            type: 'OPEN_MODAL',
            modal: 'VIEW_SAMPLE',
            props: {
              sample: original,
              closeModal: () => dispatch({ type: 'CLOSE_MODAL' }),
            },
          })
        }
      >
        {original.sample_id ?? '-'}
      </a>
    ),
    isVisible: true,
  },
  {
    id: 'subject',
    header: 'Subject',
    accessorKey: 'subject',
    size: cellWidth,
    cell: ({
      row: {
        original: { subject },
      },
    }) => {
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      if (subject?.data?.name) {
        return subject.data.name;
      }
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      if (subject?.name) {
        return subject.name;
      }
      return '-';
    },
    isVisible: true,
  },
  {
    id: 'dateTaken',
    header: 'Date taken',
    accessorKey: 'date',
    size: cellWidth,
    cell: ({
      row: {
        original: { date },
      },
    }) => <DateTimeRenderer value={date} defaultResponse="-" />,
    isVisible: true,
  },
  {
    id: 'type',
    header: 'Type',
    accessorKey: 'type',
    size: cellWidth,
    cell: ({
      row: {
        original: { type, glossary },
      },
    }) => {
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      if (type) {
        return type;
      }
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      if (glossary?.title) {
        return glossary.title;
      }
      return '-';
    },
    isVisible: true,
  },
  {
    id: 'study_groups',
    header: 'Groups',
    accessorKey: 'study_groups',
    enableSorting: false,
    size: 275,
    meta: { style: { overflow: 'visible' } },
    cell: ({ row: { original } }) => {
      if (_isNil(original.study_group_id)) {
        return '-';
      }
      return <GroupLabel group={original.study_group} />;
    },
    isVisible: true,
  },
];
